/* eslint-disable no-unused-vars */
// eslint-disable-next-line import/no-unresolved
const constants = require('onestic-base/constants');
const debounce = require('lodash/debounce');
const utils = require('onestic-base/utils');

var reducedMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
var prefersReducedMotion = reducedMotionQuery.matches;

const galleryThumbsnavCarousel = (htmlElement, additionalConfig) => {
    const { prev, next } = utils.getSliderLabels();
    $(additionalConfig.asNavFor).slick({
        slidesToShow: 5,
        slidesToScroll: 1,
        asNavFor: htmlElement,
        dots: false,
        arrows: true,
        prevArrow: `<button type="button" class="icon-left-arrow-line prev no-btn" aria-label="${prev}"></button>`,
        nextArrow: `<button type="button" class="icon-right-arrow-line next no-btn" aria-label="${next}"></button>`,
        focusOnSelect: true,
        infinite: false,
    });
};

const galleryThumbsnavCarouselVertical = (htmlElement, additionalConfig) => {
    const { prev, next } = utils.getSliderLabels();
    $(additionalConfig.asNavFor).slick({
        slidesToShow: 5,
        slidesToScroll: 1,
        asNavFor: htmlElement,
        dots: false,
        arrows: false,
        prevArrow: `<button type="button" class="icon-left-arrow-line prev no-btn" aria-label="${prev}"></button>`,
        nextArrow: `<button type="button" class="icon-right-arrow-line next no-btn" aria-label="${next}"></button>`,
        focusOnSelect: true,
        infinite: false,
        vertical: true,
        verticalSwiping: true,
    });
};

const showSlickDots = (thisElem, isCarouselModule) => {
    if (isCarouselModule) {
        thisElem.find('.slick-dots').fadeIn();
    }
};

const useCustomizableSlick = (htmlElement, haveArrows,
    slickPrevArrow, slickNextArrow,
    slidesToShow, additionalConfig) => {
    const thisElem = $(htmlElement);
    const initialConfig = {
        dots: true,
        infinite: false,
        arrows: haveArrows,
        prevArrow: slickPrevArrow,
        nextArrow: slickNextArrow,
        slidesToShow,
        draggable: true,
        speed: 100,
        swipeToSlide: true,
        touchThreshold: 7,
        responsive: [
            {
                breakpoint: constants.viewport_bootstrap.lg,
                settings: {
                    arrows: true,
                    prevArrow: slickPrevArrow,
                    nextArrow: slickNextArrow,
                },
            },
        ],
    };

    const isCarouselModule = thisElem.hasClass('carousel-module');
    const config = Object.assign(initialConfig, additionalConfig);

    // Accessibility override
    if (prefersReducedMotion) {
        config.autoplay = false;
        config.speed = 0;
    }
    
    if (!thisElem.hasClass('slick-initialized')) {
        thisElem.on('init', (event, slick, currentSlide, nextSlide) => {
            thisElem.addClass('loaded');
            if ('asNavFor' in additionalConfig && !thisElem.hasClass('carousel-set') && !$('#Cart-Show').length && !$('#Wishlist-Show').length) {
                if (thisElem.hasClass('carousel-set-vertical')) {
                    galleryThumbsnavCarouselVertical(htmlElement, additionalConfig);
                } else {
                    galleryThumbsnavCarousel(htmlElement, additionalConfig);
                }
            }
            showSlickDots(thisElem, isCarouselModule);
        });
        thisElem.each((index, node) => {
            $(node).slick(config);
        });
    } else if (!thisElem.hasClass('loaded')) {
        thisElem.each((index, node) => {
            $(node).slick('refresh');
        });
    }

    const debounceTime = 500;
    $(window).on('resize', debounce(() => {
        showSlickDots(thisElem, isCarouselModule);
    }, debounceTime));

    $(window).bind('orientationchange', debounce(() => {
        showSlickDots(thisElem, isCarouselModule);
    }, debounceTime));
};

module.exports = {
    methods: {
        useCustomizableSlick,
    },
};
